/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAllotmentGetForOpsHubResponseFromDiscriminatorValue, serializeAllotmentGetForOpsHubRequest, serializeAllotmentGetForOpsHubResponse, type AllotmentGetForOpsHubRequest, type AllotmentGetForOpsHubResponse } from '../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /OpsHub
 */
export interface OpsHubRequestBuilder extends BaseRequestBuilder<OpsHubRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AllotmentGetForOpsHubResponse[]>}
     */
     post(body: AllotmentGetForOpsHubRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AllotmentGetForOpsHubResponse[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AllotmentGetForOpsHubRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OpsHubRequestBuilderUriTemplate = "{+baseurl}/OpsHub";
/**
 * Metadata for all the requests in the request builder.
 */
export const OpsHubRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: OpsHubRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createAllotmentGetForOpsHubResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAllotmentGetForOpsHubRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
